import { Container } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";

import BackgroundImage from "../../components/background-image/BackgroundImage";
import { StyledEngineProvider } from "@mui/material";
import styles from "./Homepage.module.css";
import background from "../../assets/images/background-main-small.jpg";
import InfoBox from "./InfoBox";
import SearchBar from "./SearchBar";
import IntroductionAndMap from "./IntroductionAndMap";
import FaqSection from "./FaqSection";
import ContactSection from "./ContactSection";


type HomepagePropType = any;

export default function Homepage(props: HomepagePropType): JSX.Element {
  return (
    <StyledEngineProvider injectFirst>
      <Container className={styles.mainBgImage}></Container>
      <BackgroundImage
        // backgroundImageHeight={"800px"}
        containerClassName={styles.mainBackgroundImage}
        backgroundImage={background}
      >
        <Container className={styles.backgroundImageHeader}>
          <Grid2 container>
            <InfoBox />
          </Grid2>
        </Container>
      </BackgroundImage>
      <SearchBar />
      <IntroductionAndMap />
      <FaqSection />
      <ContactSection id="contact-section" />
    </StyledEngineProvider>
  );
}
